var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewEraLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70.575mm",
    height: "19.095mm",
    viewBox: "0 0 70.575 19.095",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.627 -44.07)",
    fill: "#10b929",
    strokeWidth: 0.070004,
    "aria-label": "Boxing Club"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.627 63.165 1.0904-7.7514h6.2012l-2.2272 3.1006h1.788l-0.65112 4.6509zm2.2014-4.6509h1.0697l1.111-1.5503h-1.9585zm-0.43408 3.1006h3.1006l0.21704-1.5503h-3.1006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.862 63.165 1.0904-7.7514h6.2012l-1.0904 7.7514zm1.7673-1.5503h3.1006l0.65629-4.6509h-3.1006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.639 59.289 1.6588 3.8757h-1.7932l-0.98185-2.2996-1.633 2.2996h-1.7932l2.7492-3.8757-1.6588-3.8757h1.7932l0.98185 2.2996 1.633-2.2996h1.7932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.421 55.413h1.5503l-1.0904 7.7514h-1.5503z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.338 56.964-0.87333 6.2012h-1.5503l1.0904-7.7514h6.2012l-1.0904 7.7514h-1.5503l0.87333-6.2012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.441 55.413-0.21704 1.5503h-4.6509l-0.65629 4.6509h3.1006l0.21704-1.5503h-1.5503l0.21704-1.5503h3.1006l-0.65112 4.6509h-6.2012l1.0904-7.7514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.777 61.614h4.6509l-0.21704 1.5503h-6.2012l1.0904-7.7514h6.2012l-0.21704 1.5503h-4.6509z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.011 61.614h4.6509l-0.21704 1.5503h-6.2012l1.0904-7.7514h1.5503z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.569 55.413h1.5503l-0.87333 6.2012h3.1006l0.87333-6.2012h1.5503l-1.0904 7.7514h-6.2012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.713 63.165 1.0904-7.7514h6.2012l-2.2272 3.1006h1.788l-0.65112 4.6509zm2.2014-4.6509h1.0697l1.111-1.5503h-1.9585zm-0.43408 3.1006h3.1006l0.21704-1.5503h-3.1006z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.627 -44.07)",
    fill: "#fff",
    strokeWidth: 0.095077,
    "aria-label": "New-Era"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.232 46.175-1.1861 8.4221h-2.1055l1.4809-10.528h8.4221l-1.4809 10.528h-2.1055l1.1861-8.4221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.166 52.492h6.3166l-0.29478 2.1055h-8.4221l1.4809-10.528h8.4221l-0.29478 2.1055h-6.3166l-0.30179 2.1055h6.3166l-0.29478 2.1055h-6.3166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.073 44.07h2.1055l-1.1861 8.4221h2.8074l1.1861-8.4221h2.1055l-1.1861 8.4221h2.8074l1.1861-8.4221h2.1055l-1.4809 10.528h-11.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.833 50.386h-6.3166l0.29478-2.1055h6.3166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.048 52.492h6.3166l-0.29478 2.1055h-8.4221l1.4809-10.528h8.4221l-0.29478 2.1055h-6.3166l-0.30179 2.1055h6.3166l-0.29478 2.1055h-6.3166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.376 44.07-0.89134 6.3166h-2.4284l1.8388 4.2111h-2.4354l-1.8388-4.2111h-1.4528l-0.58955 4.2111h-2.1055l1.4809-10.528zm-2.4003 2.1055h-4.2111l-0.30179 2.1055h4.2111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.591 46.175-0.30179 2.1055h4.2111l0.30179-2.1055zm-1.8108-2.1055h8.4221l-1.4809 10.528h-2.1055l0.58955-4.2111h-4.2111l-0.58955 4.2111h-2.1055z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEraLogo);
export default __webpack_public_path__ + "static/media/new-era-logo.105b62c6f70528fa0add6fcfdd2b95a6.svg";
export { ForwardRef as ReactComponent };